import moment from 'moment';
import CONSTANTS from './constants';

let DEFAULT_FILTERS = {
	memberships: [
		{key: 'start_date', label: 'Start Date', comparator: '>=', type: CONSTANTS.FILTERS.TYPES.DATE, defaultValue: moment().startOf('month').format(CONSTANTS.DATE.FORMAT.DISPLAY)},
		{key: 'end_date', label: 'End Date', comparator: '<=', type: CONSTANTS.FILTERS.TYPES.DATE, defaultValue: moment().endOf('year').format(CONSTANTS.DATE.FORMAT.DISPLAY)}
	],
    appointments: [
        {key: 'start_date', label: 'Start Date', comparator: '>=', type: CONSTANTS.FILTERS.TYPES.DATE, defaultValue: moment().startOf('quarter').format(CONSTANTS.DATE.FORMAT.DISPLAY)},
        {key: 'end_date', label: 'End Date', comparator: '<=', type: CONSTANTS.FILTERS.TYPES.DATE, defaultValue: moment().endOf('quarter').format(CONSTANTS.DATE.FORMAT.DISPLAY)}
    ],
    accounts: [
        {key: 'payment_method', label: 'Payment Method', comparator: '==', type: CONSTANTS.FILTERS.TYPES.STRING, defaultValue: ''},
        {key: 'bank_name', label: 'Bank Name', comparator: '==', type: CONSTANTS.FILTERS.TYPES.STRING, defaultValue: ''},
        {key: 'aba_no', label: 'Aba #', comparator: '==', type: CONSTANTS.FILTERS.TYPES.STRING, defaultValue: ''},
    ],
    pos: [
        {key: 'description', label: 'Search Products', comparator: 'contains', type: CONSTANTS.FILTERS.TYPES.STRING, defaultValue: ''}
    ]
};

export default DEFAULT_FILTERS;


// WEBPACK FOOTER //
// ./src/defaultFilters.js